import { useParams } from "react-router-dom";
import { LoadingIndicator } from "@sunrun/experience-ui-components";
import { useEffect, useRef, useState } from "react";
import { ErrorComponent } from "components/atoms/ErrorComponent";
import { HeaderContentLayout } from "components/templates/HeaderContentLayout";
import { emptyOffer } from "services/storeFront";
import { sendTrackingEvent } from "services/fullstory";
import { useAppSelector } from "store";
import { useNavigateToBuild } from "utils/useNavigateHelper";

export const CopyOfferPage = () => {
  const navigateToBuild = useNavigateToBuild();
  const [error, setError] = useState<Error>();
  const hasStarted = useRef(false);

  const { prospectId, proposalId } = useParams();
  const cognitoToken = useAppSelector(
    (state) => state.auth.cognitoToken?.token
  );

  useEffect(() => {
    if (!cognitoToken || !proposalId || !prospectId || hasStarted.current) {
      return;
    }
    hasStarted.current = true;
    sendTrackingEvent("New Offer Start", { source: "Copy Offer" });
    emptyOffer(cognitoToken, prospectId, undefined, proposalId)
      .then((result) => {
        navigateToBuild(result.id, proposalId, { skipToPricing: true });
      })
      .catch((err) => {
        setError(err as Error);
      });
  }, [cognitoToken, navigateToBuild, proposalId, prospectId]);

  if (error) {
    return (
      <HeaderContentLayout
        content={
          <ErrorComponent
            context="CopyOfferPage"
            action="Copy Offer"
            error={error}
          />
        }
        title="There was a Problem."
        description="Something went wrong. Please try refreshing the page."
      />
    );
  }
  return <LoadingIndicator fullScreen color="black" showLoadingMessage />;
};
